import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { supabase } from '@/lib/supabaseClient'
import { Toaster } from '@/components/ui/sonner'

function App() {
  const navigate = useNavigate();

  useEffect(() => {
    const checkUser = async () => {
      const { data: { session } } = await supabase.auth.getSession();
      if (session) {
        navigate('/dashboard');
      } else {
        navigate('/login');
      }
    };
    checkUser();
  }, [navigate]);

  // Test button for Sentry integration
  return (
    <div className="flex justify-center items-center min-h-screen">
      Cargando aplicación...
      <Toaster />
    </div>
  );
}

export default App;
